import { FC, useEffect } from "react";
import { initializeChat } from "../external/YlFive9Chat";
import type { InitializeChatParams } from "../external/YlFive9Chat";
import { LocaleInput } from "./LocaleInput";

export const App: FC = function App() {
  const params: InitializeChatParams = {
    locale: "en-US",
  };

  const refresh = (newLocale: string, newCountry?: string) => {
    params.locale = newLocale;
    params.country = newCountry;
    initializeChat(params);
  };

  useEffect(() => {
    initializeChat(params);
  }, []);

  return (
    <>
      Five9Chat should be shown at the bottom of this page ...
      <LocaleInput currentLocale={params.locale} currentCountry={params.country} onRefresh={refresh}/>
    </>
  );
};
